import React, { useState } from "react";
import classes from "./MediumMovieCard.module.css";
import { useNavigate } from "react-router-dom";

export type MovieData = {
  backdrop_path: string;
  id: number;
  title: string;
  name?: string;
  original_name?: string;
  original_title: string;
  overview: string;
  poster_path: string;
  media_type?: string;
  adult: boolean;
  original_language: string;
  genre_ids: string[];
  popularity: number;
  release_date: string;
  video: boolean;
  vote_average: number;
  vote_count: number;
};

const MediumMovieCard = ({
  data,
  navigateTo,
}: {
  data: MovieData;
  navigateTo: "movie" | "tv";
}) => {
  const navigate = useNavigate();
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    setStartPosition({ x: event.clientX, y: event.clientY });
    setIsDragging(false);
  };

  const handleMouseUp = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: MovieData
  ) => {
    const distance = Math.sqrt(
      Math.pow(event.clientX - startPosition.x, 2) +
        Math.pow(event.clientY - startPosition.y, 2)
    );
    if (distance < 5 && !isDragging) {
      if (navigateTo === "movie") {
        navigate(`/movies/${data?.id}/${data?.title ?? data?.name}`);
      } else {
        navigate(`/series/${data?.id}/${data?.title ?? data?.name}`);
      }
    }
  };

  const handleMouseMove = () => {
    setIsDragging(true);
  };

  return (
    <button
      className={classes.main_card}
      onMouseDown={(event) => handleMouseDown(event)}
      onMouseUp={(event) => handleMouseUp(event, data)}
      onMouseMove={handleMouseMove}
    >
      <div className={classes.main_card_image}>
        <img
          src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
            "<replace_media_id>",
            data?.poster_path
          )}`}
          alt="movie"
          className={classes.main_card_img}
        />
      </div>
    </button>
  );
};

export default MediumMovieCard;
